import api from 'utils/api';

export const login = (data) => {
    return api.post('/login', data);
}

export const getAuthUser = () => {
    return api.get('/auth-check');
}
export const merchantPermission = () => {
    return api.get('https://bbps.mtmpay.in/Admin/api/merchant/merchant-permission-data');
}
export const logoutRequest = () => {
    return api.get('/logout');
}